module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-solera.18a2942d.jpg";